import React, {useCallback, useMemo, useState} from 'react';
import {RangeSlider, Tabs} from "@shopify/polaris";
import useTranslation from "next-translate/useTranslation";
import {Card} from "@shopify/polaris";
import styles from "./styles.module.scss";
import cn from "classnames";
import {RC_NAMESPACE} from "../../../../../utils/i18nNameSpaces";

const standardFirstFreeOrders = 200;
const standardOrderCost = 0.02;
const standardDefaultPrice = 15;

const profFirstFreeOrders = 1000;
const profOrderCost = 0.01;
const profDefaultPrice = 30;

const enterPriceFreeOrders = 1000;
const enterPriceOrderCost = 0;
const enterPriceDefaultPrice = 99;

const maxRangeValue = 8600;

const valueToProf = 984;
const valueToAdv = 7958;

const rangeOffset = (value, min, max) => ((100 * (value - min)) / (max - min)) + 1;
const Index = () => {
  const [rangeValue, setRangeValue] = useState(0);
  const {t} = useTranslation(RC_NAMESPACE);
  const handleRangeSliderChange = useCallback((value) => {

    if (value > valueToProf) {
      setSelected(1);
    } else if (value < valueToProf) {
      setSelected(0);
    }

    if (value > valueToAdv) {
      setSelected(2);
    } else if (value < valueToAdv && value > valueToProf) {
      setSelected(1);
    }

    setRangeValue(value);
  }, [rangeValue]);

  const [selected, setSelected] = useState(0);

  const handleTabChange = useCallback((selectedTabIndex) => setSelected(selectedTabIndex), [],);

  const standard = useMemo(() => {
    const currentOrderCount = rangeValue - standardFirstFreeOrders <= 0 ? 0 : rangeValue - standardFirstFreeOrders;
    const ordersCost = Math.round(standardOrderCost * currentOrderCount);

    return (<div className={styles["content-wrapper"]}>
      <p className={styles["text"]}>
        <span>{t("pricing.culc.standard._1")}</span>
        <span className={styles["price--default"]}>${standardDefaultPrice}</span>
      </p>
      <p className={styles["text"]}>
        <span>
          <span>{t("pricing.culc.standard._2.before")}</span>
          <span>
            <strong> {currentOrderCount} </strong>
          </span>
          <span>{t("pricing.culc.standard._2.after")}</span>
        </span>
        <span className={styles["price--for"]}>${ordersCost}</span>
      </p>
      <p className={styles["text"]}>
        <span><strong>{t("pricing.culc.standard._3")}</strong></span>
        <span className={styles["price--total"]}>${standardDefaultPrice + ordersCost} <span
          className={styles["text"]}>{t("pricing.culc.payment")}</span></span>
      </p>
    </div>)
  }, [rangeValue]);

  const prof = useMemo(() => {
    const currentOrderCount = rangeValue - profFirstFreeOrders <= 0 ? 0 : rangeValue - profFirstFreeOrders;
    const ordersCost = Math.round(profOrderCost * currentOrderCount);

    return (<div className={styles["content-wrapper"]}>
      <p className={styles["text"]}>
        <span>{t("pricing.culc.standard._1")}</span>
        <span className={styles["price--default"]}>${profDefaultPrice}</span>
      </p>
      <p className={styles["text"]}>
        <span>
          <span>{t("pricing.culc.standard._2.before")}</span>
          <span>
            <strong> {currentOrderCount} </strong>
          </span>
          <span>{t("pricing.culc.standard._2.after")}</span>
        </span>
        <span className={styles["price--for"]}>${ordersCost}</span>
      </p>
      <p className={styles["text"]}>
        <span><strong>{t("pricing.culc.standard._3")}</strong></span>
        <span className={styles["price--total"]}>${profDefaultPrice + ordersCost} <span
          className={styles["text"]}>{t("pricing.culc.payment")}</span></span>
      </p>
    </div>)
  }, [rangeValue]);

  const enterPrice = useMemo(() => {
    return (<div className={styles["content-wrapper"]}>
      <p className={styles["text"]}>
        <span>{t("pricing.culc.standard._1")}</span>
        <span className={styles["price--default"]}>${enterPriceDefaultPrice}</span>
      </p>
      <p className={styles["text"]}>
        <span>
          <span>{t("pricing.culc.standard._2.before")}</span>
          <span>
            <strong> {rangeValue} </strong>
          </span>
          <span>{t("pricing.culc.standard._2.after")}</span>
        </span>
        <span className={styles["price--for"]}>${rangeValue === 0 ? 0 : enterPriceDefaultPrice}</span>
      </p>
      <p className={styles["text"]}>
        <span><strong>{t("pricing.culc.standard._3")}</strong></span>
        <span className={styles["price--total"]}>${enterPriceDefaultPrice} <span
          className={styles["text"]}>{t("pricing.culc.payment")}</span></span>
      </p>
    </div>)
  }, [rangeValue])

  const tabs = [
    {
      id: 'standard', content: t("pricing.standard.header")
    },
    {
      id: 'advance', content: t("pricing.advance.header")
    },
    {
      id: 'enterPrice', content: t("pricing.enterPrice.header")
    },
  ];

  const recommended = useMemo(() => {
    return (
      <>
        <div className={cn(styles["recommended"])}
             style={{left: rangeOffset(980, 0, maxRangeValue) + '%'}}>{t("pricing.culc.recommended-professional")}</div>
        <div className={cn(styles["recommended"], styles["recommended--reverse"], styles["recommended--top"])}
             style={{right: (100 - rangeOffset(7755, 0, maxRangeValue)) + "%"}}>{t("pricing.culc.recommended-enterPrice")}</div>
      </>
    )
  }, [selected, rangeValue])

  return (<div className={styles["wrapper"]}>
    <Card sectioned title={t("pricing.culc.header")}>
      <div style={{position: "relative"}}>
        <RangeSlider
          label={t("pricing.culc.label")}
          value={rangeValue}
          onChange={handleRangeSliderChange}
          output
          min={0}
          max={maxRangeValue}
        />
        {recommended}
      </div>
      <div className={styles["footer"]}>

        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} fitted>
          <Card.Section>
            {selected === 0 && standard}
            {selected === 1 && prof}
            {selected === 2 && enterPrice}
          </Card.Section>
        </Tabs>
      </div>
    </Card>
  </div>);
};

export default Index;